import React from 'react';
import { Redirect, Route, useParams } from 'react-router-dom';
import useFeatureToggle from 'hooks/useFeatureToggle';
import lazyLoad from 'utils/lazyLoad';
import { getPathsForGwtPlace, getRouterPath } from 'utils/navigation';

const UserProfilePage = lazyLoad(
  () =>
    import(/* webpackChunkName: "UserProfilePage" */ 'pages/UserProfilePage'),
);
const UserSubscriptionDetails = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "UserSubscriptionDetails" */ 'pages/UserSubscriptionDetails'
    ),
);

const useUserProfileRedirectPath = () => {
  // Handle links to legacy URLs:
  const { userId, tab } = useParams();
  const basePath = '/users';
  if (!userId) {
    return basePath;
  }
  return `${basePath}/${userId}/${tab || 'schedule'}`;
};

const UserProfileRedirect = () => (
  <Redirect to={getRouterPath(useUserProfileRedirectPath())} />
);

export default function useUserProfileRoutes() {
  const isReactUserProfileMVPEnabled = useFeatureToggle(
    'REACT_USER_PROFILE_MVP',
  );
  return [
    isReactUserProfileMVPEnabled && (
      <Route
        path={getRouterPath('/users/:userId/:tab')}
        component={UserProfilePage}
      />
    ),
    isReactUserProfileMVPEnabled && (
      <Route
        path={[
          // Handle legacy routes:
          getRouterPath('/UserProfile/:userId?/:tab?'),
          // Ensure `/:tab` is present (defaults to `schedule` in UserProfileRedirect):
          getRouterPath('/users/:userId'),
        ]}
        component={UserProfileRedirect}
      />
    ),
    <Route
      path={getPathsForGwtPlace('userSubscriptionDetails', {
        params:
          'subscriptionDomainId=:subscriptionDomainId,subscriptionId=:subscriptionId',
      })}
      component={UserSubscriptionDetails}
    />,
  ];
}
